var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(3, function (row, index) {
      return _c(
        "b-row",
        { key: index, staticClass: "my-4" },
        _vm._l(5, function (col, idx) {
          return _c(
            "b-col",
            { key: idx },
            [_c("b-skeleton", { attrs: { height: "1rem", width: "100%" } })],
            1
          )
        }),
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }